module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./WithDrawApplyView.js"));
	}, "WithDrawApplyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WithDrawApplyView!./src/pages/Shop/Member/Wallet/WithDraw/WithDrawApply/WithDrawApplyView.js
// module id = 1585
// module chunks = 418